import { StaffMember, CreateStaffDTO, UpdateStaffDTO } from '../types/staff';
import { API_BASE, getApiHeaders } from './apiClient';

const API = API_BASE;

async function apiFetch(url: string, opts?: RequestInit) {
  const res = await fetch(url, {
    ...opts,
    headers: { ...getApiHeaders(), ...(opts?.headers ?? {}) },
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}

export async function listStaff(): Promise<StaffMember[]> {
  const data = await apiFetch(`${API}/cima/staff`);
  return data.staff;
}

export async function createStaff(dto: CreateStaffDTO): Promise<StaffMember> {
  const data = await apiFetch(`${API}/cima/staff`, {
    method: 'POST',
    body: JSON.stringify(dto),
  });
  return data.staff;
}

export async function updateStaff(id: number, dto: UpdateStaffDTO): Promise<StaffMember> {
  const data = await apiFetch(`${API}/cima/staff/${id}`, {
    method: 'PUT',
    body: JSON.stringify(dto),
  });
  return data.staff;
}

export async function deleteStaff(id: number): Promise<void> {
  await apiFetch(`${API}/cima/staff/${id}`, { method: 'DELETE' });
}

export async function sendInvite(id: number): Promise<{ inviteLink: string }> {
  return apiFetch(`${API}/cima/staff/${id}/invite`, { method: 'POST' });
}

export async function validateInviteToken(token: string): Promise<{
  valid: boolean;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
}> {
  return apiFetch(`${API}/cima/staff/invite/validate?token=${token}`);
}

export async function saveInviteDetails(token: string, details: {
  phone?: string;
  jobTitle?: string;
  availableDays?: string[];
}): Promise<void> {
  await apiFetch(`${API}/cima/staff/invite/details`, {
    method: 'POST',
    body: JSON.stringify({ token, ...details }),
  });
}

export async function acceptInvite(token: string, email: string): Promise<void> {
  await apiFetch(`${API}/cima/staff/invite/accept`, {
    method: 'POST',
    body: JSON.stringify({ token, email }),
  });
}
